import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { HTTP_HOST } from 'shared/consts/https';

export const $api = axios.create({
	baseURL: HTTP_HOST,
});

$api.interceptors.request.use(config => {
	config.headers.Authorization = `Bearer ${localStorage.getItem('access')}`;
	return config;
});

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
	_isRetry?: boolean;
}

$api.interceptors.response.use(
	config => {
		return config;
	},
	async (error: AxiosError) => {
		const originalRequest = error.config as CustomAxiosRequestConfig;
		if (
			error.response?.status === 401 &&
			error.config &&
			!originalRequest._isRetry
		) {
			originalRequest._isRetry = true;
			try {
				const refresh = localStorage.getItem('refresh');

				if (!refresh) {
					window.location.pathname = '/login'
					return Promise.reject(error);
				}

				const response = await axios.post(
					`${HTTP_HOST}/api/token/refresh/`,
					{ refresh: localStorage.getItem('refresh') },
				);
				if (response) {
					localStorage.setItem('access', response.data.access);
					return $api.request(originalRequest);
				}
			} catch (e) {
				localStorage.clear();
				window.location.pathname = '/login'
				return Promise.reject(error);
			}
		}
		return Promise.reject(error);
	},
);

export default $api;
